import React from 'react'

import styles from './ProductSlider.module.scss'

import ProductCard from '../ProductCard'
import {  SlideProductCardSkeleton } from '../skeletons'

const ProductSlider = ({ productList, loading = false }: any) => {
    const productCardSkeletons = Array.from({ length: 4 }).map((_, index) => (
        <SlideProductCardSkeleton  key={`skeleton-${index}`} />

    ));
    const renderCardComponents = productList?.map((item: any, index: number) => (
        <ProductCard key={`${item.id}-${index}`} data={item} className={styles.wrapper__item} isWishlist={item?.in_wishlist} />
    ));


  return (
    <div>
      <div>
        <p className={styles.wrapper__title}>Найпопулярніші товари </p>
      </div>
      <div className={styles.wrapper}>{loading ? productCardSkeletons : renderCardComponents}</div>
    </div>
  )
}

export default ProductSlider
